import { PermissionNameFor } from '@/components/permissions/Permission.tsx';
import { Resource } from '@/components/permissions/Resource.tsx';
import { Action } from '@/components/permissions/Action.tsx';
import type { AppRouteConfig } from '../types';

export const dashboardRoutes: AppRouteConfig[] = [
  {
    path: '/dashboard',
    layout: 'MainLayout',
    element: 'ProtectedRoute',
    requiredPermission: PermissionNameFor(Resource.Dashboard, Action.View),
    children: [
      { path: null, element: 'DashboardPage', index: true },
      { path: 'my-profile', element: 'Profile' },
      { path: 'my-drive', element: 'MyDrivePage' }
    ]
  }
];
